// extracted by mini-css-extract-plugin
export default {"container":"K8JC0bZib2pbvdQo39fY","descriptionBlock":"akWrEQwas_oY5zmesHxQ","feeTermsBlock":"qNsuC26AUNzJ5SAhcElW"};